import React from "react";
import '../footer/Footer.css'
import { FaLinkedinIn } from "react-icons/fa6";
import { IoLogoGithub } from "react-icons/io";
import { FaFacebookF } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";


function Footer(){
    return(
        <>
          <div className="fot ">
            <div className="icon text-[#4db5ff] flex justify-center items-center m-auto backdrop-blur-xl">
              <a href="https://www.linkedin.com/in/ahmed-elbastawesy-372ba723b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><FaLinkedinIn /></a>
              <a href="https://github.com/Elbastawesy122"><IoLogoGithub /></a>
              <a href="https://www.facebook.com/profile.php?id=100011233788445&mibextid=ZbWKwL"><FaFacebookF /></a>
              <a href="https://wa.me/qr/HIKVUP7HABRPE1"><FaWhatsapp /></a>
            </div>
          </div>
        </>
    )
}
export default Footer;